import { render } from "./ProductPriceSolarSimpleInfoCard.vue?vue&type=template&id=0b431eb7"
import script from "./ProductPriceSolarSimpleInfoCard.vue?vue&type=script&lang=js"
export * from "./ProductPriceSolarSimpleInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__